module.exports = __webpack_public_path__ + "static/img/banner-home.66b3a0cb.jpg";